import { render, staticRenderFns } from "./ReligionPage.vue?vue&type=template&id=d97969c0"
import script from "./ReligionPage.vue?vue&type=script&lang=js"
export * from "./ReligionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports